/* global axios */
import ApiClient from './ApiClient';

class WallboardStatsAPI extends ApiClient {
  constructor() {
    super('wallboard_stats', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new WallboardStatsAPI();
